export function isFlyoutOpen(el) {
  return Boolean(el && !el.hidden);
}

export function openFlyout(el, { instant = false } = {}) {
  if (!el) {
    return;
  }

  el.hidden = false;
  el.style.removeProperty('display');

  if (instant) {
    el.classList.add('is-instant', 'is-open');
    requestAnimationFrame(() => {
      el.classList.remove('is-instant');
    });
    return;
  }

  if (!el.classList.contains('is-open')) {
    requestAnimationFrame(() => {
      el.classList.add('is-open');
    });
  }
}

export function closeFlyout(el, { instant = false } = {}) {
  if (!el) {
    return;
  }

  el.classList.remove('is-open');
  el.classList.remove('is-instant');
  el.hidden = true;
  el.style.removeProperty('display');

  if (instant) {
    return;
  }
}
